export default "__VITE_ASSET__740cb679__"